"use strict";

exports.__esModule = true;
exports.TimezoneNameField = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactFinalForm = require("react-final-form");
var _core = require("@blueprintjs/core");
var _datetime = require("@blueprintjs/datetime");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var TimezoneNameField = exports.TimezoneNameField = function TimezoneNameField() {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Field, {
    name: "name"
  }, function (_ref) {
    var input = _ref.input,
      meta = _ref.meta;
    return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      intent: meta.touched && meta.error ? "danger" : "secondary",
      helperText: meta.touched && meta.error ? meta.error : translate("TimezoneNameField.helperText", "The name of this timezone."),
      label: translate("TimezoneNameField.label", "Name"),
      labelFor: "name",
      requiredLabel: "*"
    }, /*#__PURE__*/_react["default"].createElement(_datetime.TimezoneSelect, _extends({}, input, {
      valueDisplayFormat: "composite",
      popoverProps: {
        usePortal: true,
        popoverClassName: "vi-select-popover"
      }
    })));
  });
};